export enum RequiredTimeUnit {
    YES = '!',
    NO = '?',
}

export enum Period {
    YEAR,
    MONTH,
    WEEK,
    DAY,
    HOUR,
    MINUTE,
    SECOND,
}

export enum PeriodRequired {
    Y = 'Y',
    O = 'O',
    W = 'W',
    D = 'D',
    H = 'H',
    M = 'M',
    S = 'S',
}

export enum PeriodNotRequired {
    Y = 'y',
    O = 'o',
    W = 'w',
    D = 'd',
    H = 'h',
    M = 'm',
    S = 's',
}
